<template>
  <div class="d-flex flex-column">
    <router-link
        :to="dataSport.kindOfSport + '/tour/' + tourid"
        v-for="game in games"
        :key="game.ID"
        class="py-2 game-border-bottom tour-link-container"
        :class="dataSport.kindOfSport + '_border'"
    >
      <div class="d-flex align-items-center">
        <div class="d-flex flex-grow-1">
          <div class="flex-shrink-1 align-self-center text-left game-time-block">
            <div class="font-weight-normal time-start-game text-white">
              {{ game.Time }}
            </div>
            <MlbGameState :state="game.State" :dataSport="dataSport"></MlbGameState>
          </div>
          <div class="pl-2 w-100" style="margin-left: 50px">
            <div class="d-flex justify-content-center align-items-center">
              <!-- Первый игрок -->
              <div class="text-right w-100">
                <div class="font-weight-normal team-font-size text-white" v-if="$i18n.locale === 'ru'">
                  {{ game.team1_title_short }}
                </div>
                <div class="font-weight-normal team-font-size text-white" v-else>
                  {{ game.team1_title_short_eng }}
                </div>
                <div class="small text-white-50" v-if="$i18n.locale === 'ru'">{{ game.player1_title_short }}</div>
                <div class="small text-white-50" v-else>{{ game.player1_title_short_eng }}</div>
              </div>

              <!-- Счёт -->
              <MlbGameScore :game="game" :dataSport="dataSport"></MlbGameScore>

              <!-- Второй игрок + тултип -->
              <div class="text-left w-100 d-flex align-items-center">
                <div>
                  <div class="font-weight-normal team-font-size text-white" v-if="$i18n.locale === 'ru'">
                    {{ game.team2_title_short }}
                  </div>
                  <div class="font-weight-normal team-font-size text-white" v-else>
                    {{ game.team2_title_short_eng }}
                  </div>
                  <div class="small text-white-50" v-if="$i18n.locale === 'ru'">{{ game.player2_title_short }}</div>
                  <div class="small text-white-50" v-else>{{ game.player2_title_short }}</div>
                </div>

                <!-- Тултип с типом победы -->
                <div v-if="game.ResultType && game.State === 'finished'" class="tooltip-container ml-1">
                  <span class="tooltip-icon">
                    <img :src="svgPath" alt="info icon" width="14" height="14" />
                  </span>
                  <div class="tooltip-message">
                    {{ getResultTypeMessage(game.ResultType) }}
                  </div>
                </div>
              </div>
            </div>

            <div class="periods-block text-center">
              <small class="text-nowrap">{{ game.Periods }}</small>
            </div>
          </div>
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "MlbStageGames",
  props: ["games", "tourid", "dataSport"],
  data() {
    return {
      svgPath: require("@/assets/img/info-circle.svg"),
    };
  },
  methods: {
    getShortResultType(resultType) {
      const shortTypes = {
        KO: "КО",
        TKO: "ТКО",
        SUB: "SUB",
        UDEC: "UDEC",
        SDEC: "SDEC",
        MDEC: "MDEC",
        DEC: "WIN",
        DRAW: "DRAW",
      };
      return shortTypes[resultType] || "";
    },
    getResultTypeMessage(resultType) {
      const messages = {
        KO: this.$i18n.locale === "ru" ? "Нокаут" : "Knockout",
        TKO: this.$i18n.locale === "ru" ? "Технический нокаут" : "Technical knockout",
        SUB: this.$i18n.locale === "ru" ? "Сдача" : "Submission",
        UDEC: this.$i18n.locale === "ru" ? "Единогласное решение" : "Unanimous decision",
        SDEC: this.$i18n.locale === "ru" ? "Раздельное решение" : "Split decision",
        MDEC: this.$i18n.locale === "ru" ? "Решение большинства" : "Majority decision",
        DEC: this.$i18n.locale === "ru" ? "Решение судей" : "Decision",
        DRAW: this.$i18n.locale === "ru" ? "Ничья" : "Draw",
      };
      return messages[resultType] || "";
    },
  },
  components: {
    MlbGameScore: () => import("@/components/blocks/MlbGameScore.vue"),
    MlbGameState: () => import("@/components/blocks/MlbGameState.vue"),
  },
};
</script>

<style scoped>
.team-font-size {
  font-size: 0.78rem;
}
.time-start-game {
  letter-spacing: 2px;
  font-size: 0.8rem;
}
.tour-link-container {
  text-decoration: none;
  transition: all 0.5s;
  display: flex;
  align-items: center;
}
.game-time-block {
  max-width: 56px;
  width: 100%;
}
.periods-block {
  line-height: 12px;
}
.periods-block small {
  letter-spacing: 0px;
  font-size: 0.7rem;
  color: white;
  vertical-align: text-bottom;
}

/* Стили для тултипа */
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip-icon {
  cursor: help;
  opacity: 0.7;
  transition: opacity 0.2s;
}

.tooltip-icon:hover {
  opacity: 1;
}

.tooltip-message {
  visibility: hidden;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 4px 8px;
  border-radius: 4px;
  bottom: 100%;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.75rem;
  white-space: nowrap;
  z-index: 10;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.2);
}

.tooltip-container:hover .tooltip-message {
  visibility: visible;
}
</style>
